import { Component, OnInit } from '@angular/core';
import { CompoundService } from '../_services/compound.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AddcompoundComponent } from './addcompound/addcompound.component';

@Component({
  selector: 'app-compound',
  templateUrl: './compound.component.html',
  styleUrls: ['./compound.component.css']
})
export class CompoundComponent implements OnInit {

hammeddeler:any[]=[];
  filteredhammeddeler:any[]=[];
  constructor(
    private compoundService:CompoundService,
    private modal:NgbModal,
    private toastr: ToastrService) { }
  @BlockUI('changelog') blockUIChangelog: NgBlockUI;
  ngOnInit() {
    this.getHammaddeler();
  }


  getHammaddeler(){
    this.blockUIChangelog.start('Loading..');
    this.compoundService.getCompounds().subscribe(res=>{
      this.hammeddeler=res;
      console.log(res);
      this.filteredhammeddeler=res;
      this.blockUIChangelog.stop();
    },err=>{
      this.blockUIChangelog.stop();
    });
  }

  openSaveModal(){
    const modalref=  this.modal.open(AddcompoundComponent, { size: 'xl' });
   
    modalref.result.then((result)=>{
     this.getHammaddeler();
    });
    }

    openEditModal(data:any){
      const modalref=  this.modal.open(AddcompoundComponent, { size: 'xl' });
      modalref.componentInstance.hammadde=data;
      modalref.result.then((result)=>{
       this.getHammaddeler();
      });
      }


    delete(id){
        this.compoundService.deleteCompounds(id).subscribe(res=>{
          this.getHammaddeler();
          this.toastr.success('', 'Kayıt silindi');
        });
    }

    search(data:any){
   console.log(data.target.value);
        if(data.target.value.length<3){
          this.filteredhammeddeler=this.hammeddeler;
        }
        else{
          this.filteredhammeddeler=this.hammeddeler.filter(x=>x.name.toLowerCase().includes(data.target.value.toLowerCase()));
        }
    }
}
